<template>
    <div>
      <DeniedLiquidations/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import DeniedLiquidations from '@/components/DeniedLiquidations.vue'
  
  export default {
    name: 'liquidation-approval-history-view',
    components: {
      DeniedLiquidations
    }
  }
  </script>
  